/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import ErrorMessage from '@tcp/core/src/components/features/CnC/common/molecules/ErrorMessage';
import { isClient, scrollToElement, getViewportInfo, getIconPath } from '@tcp/core/src/utils';
import { PROMOTION_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import CouponHelpModal from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/views/CouponHelpModal.view';
import CouponSkeleton from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/skeleton/CouponSkeleton.view';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import CheckoutConstants from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Image from '@tcp/core/src/components/common/atoms/Image';
import withStyles from '../../../../../../common/hoc/withStyles';
import CouponListSection from '../../../../../../common/organisms/CouponListSection';
import CouponDetailModal from './CouponDetailModal.view';
import CouponForm from '../../../molecules/CouponForm';
import { styles } from '../styles/Coupon.style';
import CollapsibleContainer from '../../../../../../common/molecules/CollapsibleContainer';
import { COUPON_REDEMPTION_TYPE } from '../../../../../../../services/abstractors/CnC/CartItemTile';
import { SPC_SECTION_TRANSITION_CONFIG } from '../../../../../../common/molecules/AccordionCard/hooks/useAccordionTransition.constants';
import { SPC_SECTION } from '../../../../SinglePageCheckout/container/SinglePageCheckout.constants';
import MyOffersCouponsView from '../../../../../account/common/organism/MyOffersCoupons/views/MyOffersCoupons.view';
import { getLocalStorage, setLocalStorage } from '../../../../../../../utils/utils.web';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblDetails,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import CouponLabels, { CHECKOUT_LABELS } from './Coupon.labels';
import MultipleCouponComponent from './MultipleCouponComp.view';

function compareImmutableLists(list1, list2) {
  return list2.filter((obj2) => !list1.some((obj1) => obj1.id === obj2.id));
}
class CouponView extends React.Component {
  checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CouponLabels);

  constructor(props) {
    super(props);
    const { availableCouponList } = props;
    this.state = {
      detailStatus: false,
      placeCashStatus: false,
      selectedCoupon: {},
      couponWithHoldingLegalText: null,
      selectedHeader:
        availableCouponList?.size > 0
          ? renderLabel(
              this.checkoutLabels?.bagPage?.lbl_couponlist_available,
              'lbl_couponlist_available'
            ) || 'Available'
          : renderLabel(
              this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
              'lbl_couponlist_applied'
            ) || 'Applied',
      lastAddedCouponCode: undefined,
    };
    this.appliedCouponError = null;
    this.appliedCouponRef = this.appliedCouponRef.bind(this);
  }

  componentDidMount() {
    const { appliedCouponList, rememberedUserFlag } = this.props;

    const currentTab =
      getLocalStorage('CURRENT_COUPON_TAB') ||
      renderLabel(
        this.checkoutLabels?.bagPage?.lbl_couponlist_available,
        'lbl_couponlist_available'
      );

    if (currentTab && !rememberedUserFlag) {
      this.setState({
        selectedHeader:
          appliedCouponList?.size > 0
            ? currentTab
            : renderLabel(
                this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                'lbl_couponlist_available'
              ),
      });
      setLocalStorage({
        key: 'CURRENT_COUPON_TAB',
        value: currentTab,
      });
    } else if (rememberedUserFlag && appliedCouponList?.size > 0) {
      this.setState({
        selectedHeader: renderLabel(
          this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
          'lbl_couponlist_applied'
        ),
      });
      setLocalStorage({
        key: 'CURRENT_COUPON_TAB',
        value: renderLabel(
          this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
          'lbl_couponlist_applied'
        ),
      });
    } else {
      setLocalStorage({
        key: 'CURRENT_COUPON_TAB',
        value: renderLabel(
          this.checkoutLabels?.bagPage?.lbl_couponlist_available,
          'lbl_couponlist_available'
        ),
      });
    }
  }

  checkForTabPersist = (prevAppliedCouponList) => {
    const { appliedCouponList } = this.props;

    if (appliedCouponList && appliedCouponList?.size !== prevAppliedCouponList?.size) {
      const currentTab = getLocalStorage('CURRENT_COUPON_TAB');
      this.setState({
        selectedHeader:
          appliedCouponList?.size > 0
            ? currentTab
            : renderLabel(
                this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                'lbl_couponlist_available'
              ),
      });
    }
  };

  checkForRememberUser = (prevProps) => {
    const { rememberedUserFlag, appliedCouponList } = this.props;

    if (
      rememberedUserFlag !== prevProps?.rememberedUserFlag &&
      rememberedUserFlag &&
      appliedCouponList?.size > 0
    ) {
      this.setState({
        selectedHeader: renderLabel(
          this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
          'lbl_couponlist_applied'
        ),
      });
      setLocalStorage({
        key: 'CURRENT_COUPON_TAB',
        value: renderLabel(
          this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
          'lbl_couponlist_applied'
        ),
      });
    }
  };

  componentDidUpdate(prevProps) {
    const {
      appliedExpiredCoupon,
      isFetching,
      bagLoading,
      availableCouponList,
      appliedCouponList,
      fromIsApplyAction,
      fromApplyCTA,
    } = this.props;

    this.checkForRememberUser(prevProps);
    const prevCouponsList = prevProps.availableCouponList;
    const prevAppliedCouponList = prevProps.appliedCouponList;
    if (
      appliedExpiredCoupon?.size > 0 &&
      (appliedExpiredCoupon?.size !== prevProps.appliedExpiredCoupon?.size ||
        isFetching !== prevProps.isFetching ||
        bagLoading !== prevProps.bagLoading)
    ) {
      scrollToElement(this.appliedCouponError);
    }
    if (availableCouponList !== prevCouponsList && this.state.selectedCoupon !== null) {
      const lastAddedCouponNew = compareImmutableLists(prevAppliedCouponList, appliedCouponList);
      const lastAddedCouponCodeNew = lastAddedCouponNew?.get(0)?.id;
      this.switchTabs(lastAddedCouponCodeNew);
      availableCouponList.forEach((cpn) => {
        if (cpn.id === this.state.selectedCoupon.id)
          this.setState({ couponWithHoldingLegalText: cpn });
      });
    }
    this.checkForTabPersist(prevAppliedCouponList);
    this.checkIfCurrentTabIsActiveTab(prevProps);

    if (
      appliedCouponList &&
      appliedCouponList?.size !== prevAppliedCouponList?.size &&
      this.state.selectedCoupon !== null &&
      fromApplyCTA
    ) {
      const lastAddedCoupon = compareImmutableLists(prevAppliedCouponList, appliedCouponList);
      const lastAddedCouponCode = lastAddedCoupon?.get(0)?.id;
      this.setState(
        {
          selectedHeader:
            appliedCouponList?.size > 0
              ? renderLabel(
                  this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                  'lbl_couponlist_applied'
                )
              : renderLabel(
                  this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                  'lbl_couponlist_applied'
                ),
          lastAddedCouponCode,
        },

        this.updateLocalStorage(appliedCouponList, this.checkoutLabels)
      );
      fromIsApplyAction(false);
    }
  }

  updateLocalStorage = (appliedCouponList) => {
    const value =
      appliedCouponList?.size > 0
        ? renderLabel(
            this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
            'lbl_couponlist_applied'
          )
        : renderLabel(
            this.checkoutLabels?.bagPage?.lbl_couponlist_available,
            'lbl_couponlist_available'
          );

    setLocalStorage({
      key: 'CURRENT_COUPON_TAB',
      value,
    });
  };

  checkIfCurrentTabIsActiveTab = (prevProps) => {
    const { fromApplyCTA, appliedCouponList, availableCouponList } = this.props;
    const prevAppliedCouponList = prevProps?.appliedCouponList;

    if (
      !fromApplyCTA &&
      appliedCouponList?.size !== 0 &&
      availableCouponList?.size === 0 &&
      appliedCouponList?.size !== prevAppliedCouponList?.size
    ) {
      this.setState(
        {
          selectedHeader:
            appliedCouponList?.size > 0
              ? renderLabel(
                  this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                  'lbl_couponlist_applied'
                )
              : renderLabel(
                  this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                  'lbl_couponlist_available'
                ),
        },
        this.updateLocalStorage(appliedCouponList, this.checkoutLabels)
      );
    }
  };

  switchTabs = (lastAddedCouponCode1) => {
    const { appliedCouponList, fromApplyCTA } = this.props;

    if (lastAddedCouponCode1 && fromApplyCTA) {
      this.setState({
        selectedHeader:
          appliedCouponList?.size > 0
            ? renderLabel(
                this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                'lbl_couponlist_applied'
              )
            : renderLabel(
                this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                'lbl_couponlist_available'
              ),
        lastAddedCouponCode: lastAddedCouponCode1,
      });
    }
  };

  couponDetailClick = (coupon) => {
    const { fetchCouponTermsAndConditions } = this.props;
    if (!coupon.legalText && coupon.promotionId) fetchCouponTermsAndConditions(coupon);
    this.setState({
      detailStatus: true,
      selectedCoupon: coupon,
    });
  };

  couponPlaceCashClick = () => {
    const { contentLabels, fetchNeedHelpContent, placeCashContentId } = this.props;
    if (!contentLabels.PLACE_CASH_CONTENT) {
      fetchNeedHelpContent([placeCashContentId]);
    }
    this.setState({
      placeCashStatus: true,
    });
  };

  toggleCouponNeedHelpModal = ({ status } = {}) => {
    const { toggleNeedHelpModal, contentLabels, fetchNeedHelpContent, needHelpContentId } =
      this.props;
    if (status === 'open' && !contentLabels.NEED_HELP_RICH_TEXT) {
      fetchNeedHelpContent([needHelpContentId]);
    }
    toggleNeedHelpModal();
  };

  getHeader = ({ spc }) => {
    return (
      <>
        <div className={`${spc ? 'spc-card-heading' : 'elem-mb-SM'} rewards-header `}>
          {spc ? (
            <>
              <BodyCopy component="div" className="spc-form-heading">
                <Image
                  className="header-icon elem-pr-XS"
                  width="26px"
                  height="26px"
                  src={getIconPath('rewards')}
                  alt="reward-icon"
                  data-locator="reward-icon"
                  aria-hidden="true"
                />

                <BodyCopy
                  component="h2"
                  className="spc-card-heading spc-title"
                  data-locator="rewards-heading"
                >
                  {renderLabel(
                    this.checkoutLabels?.bagPage?.lbl_coupon_collapsible_header,
                    'lbl_coupon_collapsible_header'
                  )}
                </BodyCopy>
              </BodyCopy>

              <Button
                buttonVariation="category-links-dark"
                dataLocator="couponDetails"
                noLink
                className={`sflActions spc-header-action expand-details-button ${'actionClassName'}`}
                aria-label={renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                    GlobalGenericLabels
                  ),
                  'lbl_details'
                )}
                aria-hidden="true"
                tabindex="-1"
              >
                <BodyCopy
                  fontFamily="secondary"
                  fontSize="fs14"
                  component="span"
                  fontWeight={['semibold']}
                  className="expand-details-button coupon-action"
                >
                  <span className="coupon-action-label">
                    {renderLabel(
                      getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                        GlobalGenericLabels
                      ),
                      'lbl_details'
                    )}
                  </span>
                </BodyCopy>
              </Button>
            </>
          ) : (
            <BodyCopy fontFamily="secondary" fontSize="fs16" fontWeight="semibold" component="span">
              {renderLabel(
                this.checkoutLabels?.bagPage?.lbl_coupon_collapsible_header,
                'lbl_coupon_collapsible_header'
              )}
            </BodyCopy>
          )}
        </div>
      </>
    );
  };

  getSubHeadingContent = ({
    availableCouponList,
    appliedCouponList,
    onHoldCouponList,
    couponOnHoldNewDesign,
  }) => {
    const appliedCouponListWithoutOnHold = appliedCouponList?.filter(
      (item) => item.isOnHold !== 'true'
    );
    return (
      <div className="elem-ml-XL_1 elem-mt-SM spc-form-heading">
        {availableCouponList && availableCouponList?.size > 0 && (
          <BodyCopy
            className="couponList__heading "
            fontWeight="semibold"
            component="h2"
            fontSize="fs14"
            data-locator="coupon-cartAvaliableRewards"
            fontFamily="secondary"
            color="gray.800"
          >
            {`${renderLabel(
              this.checkoutLabels?.bagPage?.lbl_couponlist_available,
              'lbl_couponlist_available'
            )}  (${availableCouponList?.size})`}
          </BodyCopy>
        )}
        {availableCouponList?.size > 0 &&
          (appliedCouponListWithoutOnHold?.size > 0 || onHoldCouponList.size > 0) && (
            <BodyCopy
              fontFamily="secondary"
              fontSize="fs14"
              fontWeight="semibold"
              numberOfLines={1}
              className={'elem-mr-XS'}
            >
              {`, `}
            </BodyCopy>
          )}
        {couponOnHoldNewDesign && onHoldCouponList && onHoldCouponList.size > 0 && (
          <>
            <span className="on-hold-notification">!</span>
            <BodyCopy
              className="couponList__heading"
              component="h2"
              fontSize="fs14"
              data-locator="coupon-cartAvaliableRewards"
              fontFamily="secondary"
              color="gray.800"
            >
              {`Unapplied (${onHoldCouponList?.size})`}
            </BodyCopy>
            {appliedCouponListWithoutOnHold?.size > 0 && (
              <BodyCopy
                component="h2"
                fontSize="fs14"
                className={'elem-mr-XS'}
                data-locator="coupon-cartAvaliableRewards"
                fontFamily="secondary"
              >
                {`, `}
              </BodyCopy>
            )}
          </>
        )}

        {appliedCouponListWithoutOnHold && appliedCouponListWithoutOnHold?.size > 0 && (
          <BodyCopy
            className="couponList__heading"
            fontWeight="semibold"
            component="h2"
            fontSize="fs14"
            data-locator="coupon-cartAvaliableRewards"
            fontFamily="secondary"
            color="gray.800"
          >
            {` ${renderLabel(
              this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
              'lbl_couponlist_applied'
            )} (${appliedCouponListWithoutOnHold?.size})`}
          </BodyCopy>
        )}
      </div>
    );
  };

  getAvailableCouponList = ({
    bagLoading,
    availableCouponList,
    handleApplyCouponFromList,
    isFetching,
    handleErrorCoupon,
    additionalClassName,
    spc,
    spcBag,
    handleRemoveCoupon,
    fromPaymentModal,
    afterpayCouponsInfo,
    setBonusPointDayCouponIndexAction,
    currentPerkLevel,
    allCouponList,
  }) => {
    if (!bagLoading) {
      return (
        availableCouponList &&
        availableCouponList.size > 0 && (
          <CouponListSection
            isFetching={isFetching}
            couponList={allCouponList}
            className="available_coupon"
            heading={renderLabel(
              this.checkoutLabels?.bagPage?.lbl_couponlist_available,
              'lbl_couponlist_available'
            )}
            helpSubHeading="true"
            couponDetailClick={this.couponDetailClick}
            helpAnchorClick={this.couponPlaceCashClick}
            onApply={handleApplyCouponFromList}
            dataLocator="coupon-cartAvaliableRewards"
            handleErrorCoupon={handleErrorCoupon}
            additionalClassNameModal={additionalClassName}
            showFullList={spc ? 'showFullList' : ''}
            spc={spc}
            spcBag={spcBag}
            onRemove={handleRemoveCoupon}
            fromPaymentModal={fromPaymentModal}
            afterpayCouponsInfo={afterpayCouponsInfo}
            setBonusPointDayCouponIndexAction={setBonusPointDayCouponIndexAction}
            currentPerkLevel={currentPerkLevel}
            checkoutLabels={this.checkoutLabels}
          />
        )
      );
    }

    return (
      <CouponSkeleton
        className
        heading={renderLabel(
          this.checkoutLabels?.bagPage?.lbl_couponlist_available,
          'lbl_couponlist_available'
        )}
        couponList={availableCouponList}
        checkoutLabels={this.checkoutLabels}
      />
    );
  };

  couponExpiredError = (appliedExpiredCoupon) => {
    return (
      <>
        {appliedExpiredCoupon.map((coupon, i) => {
          if (i === 0) {
            const { id } = coupon;
            const errorMessage = renderLabel(
              this.checkoutLabels?.bagPage?.lbl_coupon_expired_error,
              'lbl_coupon_expired_error'
            )?.replace('coupon_placeholder', id);
            return <ErrorMessage error={errorMessage} className="expired-coupon-error" />;
          }
          return null;
        })}
      </>
    );
  };

  showCouponConatiner = (availableCouponList, appliedCouponList, onHoldCouponList) =>
    (availableCouponList && availableCouponList.size > 0) ||
    (appliedCouponList && appliedCouponList.size > 0) ||
    (onHoldCouponList && onHoldCouponList.size > 0);

  getErrorFromAvailable = (availableCouponList, spc) => {
    const couponError =
      availableCouponList?.size > 0
        ? availableCouponList.find((coupon) => coupon.error !== '' && coupon.error !== null && spc)
        : '';
    if (couponError && couponError?.offerType === COUPON_REDEMPTION_TYPE.PLACECASH) {
      couponError.isPlaceCashError = CheckoutConstants.PLACE_CASH;
    }
    return couponError || '';
  };

  setNewHeader = (newHeader) => {
    this.setState({ selectedHeader: newHeader });
  };

  filterPlaceBucksCoupons = (coupons) => {
    return coupons?.filter(({ offerType, isStarted }) => offerType === 'PLACECASH' && isStarted);
  };

  getAllCoupons = ({ couponOnHoldNewDesign, allCouponList }) => {
    return !couponOnHoldNewDesign
      ? allCouponList?.filter(
          (cpn) => cpn?.status !== 'notActive' && (!cpn.isOnHold || cpn.isOnHold === 'false')
        )
      : allCouponList?.filter(
          (cpn) => cpn?.status !== 'notActive' && (cpn.isOnHold || cpn.isOnHold !== 'false')
        );
  };

  getSelectedCouponList = ({ availableCouponList, appliedCouponListWithoutOnHold }) => {
    return this.state.selectedHeader ===
      renderLabel(
        this.checkoutLabels?.bagPage?.lbl_couponlist_available,
        'lbl_couponlist_available'
      )
      ? availableCouponList
      : appliedCouponListWithoutOnHold;
  };

  getOnholdCond = ({ couponOnHoldNewDesign, onHoldCouponList }) => {
    return couponOnHoldNewDesign && onHoldCouponList && onHoldCouponList.size > 0;
  };

  renderAddMultipleCouponComp = ({
    multiAddCouponErrorState,
    setMultiAddCpnSuccessAction,
    multiAddCouponSuccess,
    multiAddCouponLoader,
    applyPlaceBucksCouponsAction,
    isApplyMultipleCouponsEnabled,
    containsPlaceBucksCoupon,
    availableCouponList,
  }) => {
    const { resetCouponError } = this.props;
    if (isApplyMultipleCouponsEnabled && containsPlaceBucksCoupon?.size > 0) {
      return (
        <MultipleCouponComponent
          availableCouponList={availableCouponList}
          applyPlaceBucksCouponsAction={applyPlaceBucksCouponsAction}
          multiAddCouponLoader={multiAddCouponLoader}
          multiAddCouponSuccess={multiAddCouponSuccess}
          setMultiAddCpnSuccessAction={setMultiAddCpnSuccessAction}
          multiAddCouponErrorState={multiAddCouponErrorState}
          resetCouponError={resetCouponError}
        />
      );
    }
    return null;
  };

  renderCouponHeader = ({
    availableCouponList,
    appliedCouponListWithoutOnHold,
    onHoldCouponList,
    couponOnHoldNewDesign,
  }) => {
    return (
      <section className="coupon_header">
        {availableCouponList?.size > 0 && (
          <BodyCopy
            className="couponList__heading"
            component="h2"
            fontSize="fs14"
            data-locator="coupon-cartAvaliableRewards"
            fontFamily="secondary"
          >
            {`${renderLabel(
              this.checkoutLabels?.bagPage?.lbl_couponlist_available,
              'lbl_couponlist_available'
            )} (${availableCouponList?.size})`}
          </BodyCopy>
        )}

        {availableCouponList?.size > 0 &&
          (appliedCouponListWithoutOnHold?.size > 0 || onHoldCouponList.size > 0) && (
            <BodyCopy
              className="couponList__heading elem-mr-XS"
              component="h2"
              fontSize="fs14"
              data-locator="coupon-cartAvaliableRewards"
              fontFamily="secondary"
            >
              {','}
            </BodyCopy>
          )}

        {this.getOnholdCond({ couponOnHoldNewDesign, onHoldCouponList }) && (
          <>
            <span className="on-hold-notification">!</span>
            <BodyCopy
              className="couponList__heading"
              component="h2"
              fontSize="fs14"
              data-locator="coupon-cartAvaliableRewards"
              fontFamily="secondary"
            >
              {`Unapplied (${onHoldCouponList?.size})`}
            </BodyCopy>
            {appliedCouponListWithoutOnHold?.size > 0 && (
              <BodyCopy
                className="couponList__heading elem-mr-XS"
                component="h2"
                fontSize="fs14"
                data-locator="coupon-cartAvaliableRewards"
                fontFamily="secondary"
              >
                {','}
              </BodyCopy>
            )}
          </>
        )}
        {appliedCouponListWithoutOnHold?.size > 0 && (
          <BodyCopy
            className="couponList__heading"
            component="h2"
            fontSize="fs14"
            data-locator="coupon-cartAvaliableRewards"
            fontFamily="secondary"
          >
            {`${renderLabel(
              this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
              'lbl_couponlist_applied'
            )} (${appliedCouponListWithoutOnHold?.size})`}
          </BodyCopy>
        )}
      </section>
    );
  };

  getCouponListClassName = ({
    spcBag,
    couponContainerVisible,
    availableCouponList,
    appliedCouponListWithoutOnHold,
    onHoldCouponList,
  }) => {
    return spcBag &&
      couponContainerVisible &&
      this.showCouponConatiner(
        availableCouponList,
        appliedCouponListWithoutOnHold,
        onHoldCouponList
      )
      ? 'elem-pt-SM elem-pb-SM elem-pl-SM elem-pr-SM'
      : '';
  };

  getContent = ({
    isFetching,
    contentLabels,
    handleApplyCoupon,
    handleApplyCouponFromList,
    appliedCouponList,
    availableCouponList,
    className,
    detailStatus,
    detailedCoupon,
    additionalClassName,
    idPrefix,
    showCouponMergeError,
    onHoldCouponList,
    spc,
    spcBag,
    couponTextBoxError,
    multiUseCouponList,
    placeCashStatus,
    fromPaymentModal,
    appliesCouponSuccess,
    setAppliedCOuponStatusAction,
    couponOnHoldNewDesign,
    isBonusPointDayEnabled,
    fromCouponTabAction,
    fromIsApplyAction,
    fromApplyCTA,
    allCouponList,
    isNewCouponUXWithoutTabEnabled,
    isSiteWidePromoAbtestEnabled,
    applyPlaceBucksCouponsAction,
    isApplyMultipleCouponsEnabled,
    multiAddCouponLoader,
    multiAddCouponSuccess,
    setMultiAddCpnSuccessAction,
    multiAddCouponErrorState,
  }) => {
    const appliedCouponListWithoutOnHold = appliedCouponList?.filter(
      (item) => item.isOnHold !== 'true'
    );
    const couponContainerVisible = this.showCouponConatiner(
      availableCouponList,
      appliedCouponListWithoutOnHold,
      onHoldCouponList
    );
    const { lastAddedCouponCode } = this.state;
    const allCoupons = this.getAllCoupons({ couponOnHoldNewDesign, allCouponList });
    const selectedCouponList = this.getSelectedCouponList({
      availableCouponList,
      appliedCouponListWithoutOnHold,
    });

    const containsPlaceBucksCoupon = this.filterPlaceBucksCoupons(availableCouponList);
    return (
      <div className={`${className} ${spc ? 'spc-card-content' : ''}`} ref={this.appliedCouponRef}>
        {!fromPaymentModal && (
          <>
            <CouponForm
              onSubmit={handleApplyCoupon}
              isFetching={isFetching}
              source="form"
              additionalClassNameModal={additionalClassName}
              idPrefix={idPrefix}
              coupon={detailedCoupon}
              showCouponMergeError={showCouponMergeError}
              spc={spc}
              spcBag={spcBag}
              multiUseCouponList={multiUseCouponList}
              appliesCouponSuccess={appliesCouponSuccess}
              setAppliedCOuponStatusAction={setAppliedCOuponStatusAction}
              fromIsApplyAction={fromIsApplyAction}
              checkoutLabels={this.checkoutLabels}
            />
          </>
        )}
        {this.renderAddMultipleCouponComp({
          multiAddCouponErrorState,
          setMultiAddCpnSuccessAction,
          multiAddCouponSuccess,
          multiAddCouponLoader,
          applyPlaceBucksCouponsAction,
          isApplyMultipleCouponsEnabled,
          containsPlaceBucksCoupon,
          availableCouponList,
        })}
        <div
          className={`coupon_list ${this.getCouponListClassName({
            spcBag,
            couponContainerVisible,
            availableCouponList,
            appliedCouponListWithoutOnHold,
            onHoldCouponList,
          })}
           ${couponContainerVisible ? '' : 'd-none'}`}
        >
          {
            <>
              {isNewCouponUXWithoutTabEnabled ? (
                <div className="coupon-container-new-design">
                  {this.renderCouponHeader({
                    availableCouponList,
                    appliedCouponListWithoutOnHold,
                    onHoldCouponList,
                    couponOnHoldNewDesign,
                  })}
                  <section className="coupon__list">
                    <MyOffersCouponsView
                      {...this.props}
                      labels={contentLabels}
                      allCouponList={allCoupons}
                      isAccountDrawer={true}
                      isCarouselView={true}
                      isCartPageCouponSection={true}
                      isFromBagPage={true}
                      spc={spc}
                      isBonusPointDayEnabled={isBonusPointDayEnabled}
                      lastAddedCouponCode={lastAddedCouponCode}
                      fromIsApplyAction={fromIsApplyAction}
                      fromApplyCTA={fromApplyCTA}
                      isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
                    />
                  </section>
                </div>
              ) : (
                <div className="coupon-container-new-design">
                  <section className="couponList__title">
                    {availableCouponList?.size > 0 && (
                      <Button
                        className={`couponList__header__button ${
                          this.state.selectedHeader ===
                            renderLabel(
                              this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                              'lbl_couponlist_available'
                            ) && appliedCouponList?.size > 0
                            ? 'couponList__header__active'
                            : ''
                        }`}
                        data-locator="coupon-cartAvaliableRewards"
                        noLink
                        aria-label={renderLabel(
                          this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                          'lbl_couponlist_available'
                        )}
                        aria-hidden="true"
                        onClick={() => {
                          this.setNewHeader(
                            renderLabel(
                              this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                              'lbl_couponlist_available'
                            )
                          );
                          fromCouponTabAction(true);
                          setLocalStorage({
                            key: 'CURRENT_COUPON_TAB',
                            value: renderLabel(
                              this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                              'lbl_couponlist_available'
                            ),
                          });
                        }}
                        noCurve
                      >
                        <BodyCopy
                          className="couponList__heading"
                          component="h2"
                          fontSize="fs14"
                          data-locator="coupon-cartAvaliableRewards"
                          fontFamily="secondary"
                        >
                          {`${renderLabel(
                            this.checkoutLabels?.bagPage?.lbl_couponlist_available,
                            'lbl_couponlist_available'
                          )} (${availableCouponList?.size})`}
                        </BodyCopy>
                      </Button>
                    )}
                    {this.getOnholdCond({ couponOnHoldNewDesign, onHoldCouponList }) && (
                      <span className="on-hold-notification">!</span>
                    )}
                    {appliedCouponList?.size > 0 && (
                      <Button
                        className={`couponList__header__button ${
                          this.state.selectedHeader ===
                            renderLabel(
                              this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                              'lbl_couponlist_applied'
                            ) && availableCouponList?.size > 0
                            ? 'couponList__header__active'
                            : ''
                        }`}
                        dataLocator="coupon-cartAppliedRewards"
                        noLink
                        aria-label={renderLabel(
                          this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                          'lbl_couponlist_applied'
                        )}
                        aria-hidden="true"
                        tabindex="-1"
                        onClick={() => {
                          this.setNewHeader(
                            renderLabel(
                              this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                              'lbl_couponlist_applied'
                            )
                          );
                          fromCouponTabAction(true);
                          setLocalStorage({
                            key: 'CURRENT_COUPON_TAB',
                            value: renderLabel(
                              this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                              'lbl_couponlist_applied'
                            ),
                          });
                        }}
                        noCurve
                      >
                        <BodyCopy
                          className="couponList__heading"
                          component="h2"
                          fontSize="fs14"
                          dataLocator="coupon-cartAppliedRewards"
                          fontFamily="secondary"
                        >
                          {`${renderLabel(
                            this.checkoutLabels?.bagPage?.lbl_couponlist_applied,
                            'lbl_couponlist_applied'
                          )} (${appliedCouponList?.size})`}
                        </BodyCopy>
                      </Button>
                    )}
                  </section>
                  {selectedCouponList?.size > 0 && (
                    <section className="coupon__list">
                      <MyOffersCouponsView
                        {...this.props}
                        allCouponList={selectedCouponList}
                        isAccountDrawer={true}
                        isCarouselView={true}
                        isCartPageCouponSection={true}
                        spc={spc}
                        isBonusPointDayEnabled={isBonusPointDayEnabled}
                        lastAddedCouponCode={lastAddedCouponCode}
                        fromIsApplyAction={fromIsApplyAction}
                        fromApplyCTA={fromApplyCTA}
                        allCoupons={allCouponList}
                        isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
                        isSiteWidePromoAbtestEnabled={isSiteWidePromoAbtestEnabled}
                      />
                    </section>
                  )}
                </div>
              )}
            </>
          }
          {/* UX timer for coupons list visibility */}
          <RenderPerf.Measure name={PROMOTION_VISIBLE} />
          <CouponDetailModal
            openState={detailStatus}
            coupon={detailedCoupon}
            onRequestClose={() => {
              this.setState({
                detailStatus: false,
                couponWithHoldingLegalText: null,
              });
            }}
            onApplyCouponToBagFromList={handleApplyCouponFromList}
            additionalClassNameModal={additionalClassName}
            multiUseCouponList={multiUseCouponList}
          />
        </div>

        {spc && (
          <ErrorMessage
            fontSize="fs12"
            fontWeight="extrabold"
            className="coupon_error_message"
            icon="circle-info-red"
            noBackground
            error={couponTextBoxError?.msg}
            isEspot={couponTextBoxError?.isPlaceCashError}
          />
        )}
        <CouponHelpModal
          labels={contentLabels}
          openState={placeCashStatus}
          isPlaceCashStatus={placeCashStatus}
          onRequestClose={() => {
            this.setState({
              placeCashStatus: false,
            });
          }}
        />
        {/* <ApplyNowModal /> */}
      </div>
    );
  };

  scrollToBottom = () => {
    const { isDesktop } = getViewportInfo();
    if (isClient() && isDesktop) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  };

  appliedCouponRef(ref) {
    this.appliedCouponError = ref;
  }

  render() {
    const {
      isFetching,
      handleApplyCoupon,
      handleApplyCouponFromList,
      appliedCouponList,
      availableCouponList,
      className,
      handleRemoveCoupon,
      handleErrorCoupon,
      showAccordian,
      additionalClassNameModal,
      idPrefix,
      bagLoading,
      isNeedHelpModalOpen,
      appliedExpiredCoupon,
      showCouponMergeError,
      onHoldCouponList,
      spc,
      spcBag,
      couponTextBoxError,
      multiUseCouponList,
      fromPaymentModal,
      afterpayCouponsInfo,
      appliesCouponSuccess,
      setAppliedCOuponStatusAction,
      couponOnHoldNewDesign,
      isBonusPointDayEnabled,
      fromCouponTabAction,
      setBonusPointDayCouponIndexAction,
      currentPerkLevel,
      fromIsApplyAction,
      fromApplyCTA,
      allCouponList,
      isNewCouponUXWithoutTabEnabled,
      contentLabels,
      applyPlaceBucksCouponsAction,
      isApplyMultipleCouponsEnabled,
      multiAddCouponLoader,
      multiAddCouponSuccess,
      setMultiAddCpnSuccessAction,
      multiAddCouponErrorState,
    } = this.props;
    const { detailStatus, selectedCoupon, placeCashStatus, couponWithHoldingLegalText } =
      this.state;
    const detailedCoupon =
      couponWithHoldingLegalText !== null ? couponWithHoldingLegalText : selectedCoupon;

    const header = this.getHeader({
      checkoutLabels: this.checkoutLabels,
      spc,
    });
    const subHeader = this.getSubHeadingContent({
      checkoutLabels: this.checkoutLabels,
      availableCouponList,
      appliedCouponList,
      onHoldCouponList,
      couponOnHoldNewDesign,
    });
    const body = (additionalClassName) =>
      this.getContent({
        isFetching,
        checkoutLabels: this.checkoutLabels,
        handleApplyCoupon,
        handleApplyCouponFromList,
        appliedCouponList,
        availableCouponList,
        className,
        bagLoading,
        handleRemoveCoupon,
        handleErrorCoupon,
        detailStatus,
        placeCashStatus,
        detailedCoupon,
        additionalClassName,
        idPrefix,
        isNeedHelpModalOpen,
        appliedExpiredCoupon,
        showCouponMergeError,
        onHoldCouponList,
        spc,
        spcBag,
        couponTextBoxError,
        multiUseCouponList,
        fromPaymentModal,
        afterpayCouponsInfo,
        appliesCouponSuccess,
        setAppliedCOuponStatusAction,
        couponOnHoldNewDesign,
        isBonusPointDayEnabled,
        fromCouponTabAction,
        setBonusPointDayCouponIndexAction,
        currentPerkLevel,
        fromIsApplyAction,
        fromApplyCTA,
        allCouponList,
        isNewCouponUXWithoutTabEnabled,
        contentLabels,
        applyPlaceBucksCouponsAction,
        isApplyMultipleCouponsEnabled,
        multiAddCouponLoader,
        multiAddCouponSuccess,
        setMultiAddCpnSuccessAction,
        multiAddCouponErrorState,
      });
    const defaultOpen = availableCouponList && availableCouponList.size > 0;
    return (
      <div className={className}>
        <Col
          colSize={{
            large: 12,
            medium: 8,
            // eslint-disable-next-line max-lines
            small: 6,
          }}
          ignoreGutter={{ small: true }}
          className="coupon-sec"
        >
          <CollapsibleContainer
            className={`${className} ${
              showAccordian || spc ? 'couponsWrapperAccordian' : 'rounded-container'
            }`}
            header={header}
            subHeader={subHeader}
            body={body(additionalClassNameModal)}
            iconLocator="arrowicon"
            defaultOpen={spc ? false : defaultOpen}
            isDefaultView={!showAccordian}
            showHeaderAlways={spc}
            spc={spc}
            transitionConfig={
              spc ? SPC_SECTION_TRANSITION_CONFIG[SPC_SECTION.REWARDS_AND_OFFERS] : undefined
            }
            containerId="rewards-offer-section"
            onToggleCallback={spc ? this.scrollToBottom : () => {}}
          />
        </Col>
      </div>
    );
  }
}

CouponView.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  handleApplyCoupon: PropTypes.func.isRequired,
  handleRemoveCoupon: PropTypes.func.isRequired,
  appliedCouponList: PropTypes.shape([]).isRequired,
  availableCouponList: PropTypes.shape([]).isRequired,
  additionalClassNameModal: PropTypes.string.isRequired,
  handleErrorCoupon: PropTypes.func.isRequired,
  showAccordian: PropTypes.bool.isRequired,
  toggleNeedHelpModal: PropTypes.func.isRequired,
  isNeedHelpModalOpen: PropTypes.bool.isRequired,
  fetchNeedHelpContent: PropTypes.func.isRequired,
  placeCashContentId: PropTypes.shape({}).isRequired,
  needHelpContentId: PropTypes.shape({}).isRequired,
  handleApplyCouponFromList: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  idPrefix: PropTypes.bool.isRequired,
  bagLoading: PropTypes.bool.isRequired,
  appliedExpiredCoupon: PropTypes.shape({ size: PropTypes.number }),
  showCouponMergeError: PropTypes.bool,
  onHoldCouponList: PropTypes.shape([]),
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
  couponTextBoxError: PropTypes.shape({}),
  fetchCouponTermsAndConditions: PropTypes.func.isRequired,
};

CouponView.defaultProps = {
  appliedExpiredCoupon: [],
  showCouponMergeError: false,
  onHoldCouponList: [],
  spc: false,
  spcBag: false,
  couponTextBoxError: '',
};

export default withStyles(errorBoundary(CouponView), styles);
export { CouponView as CouponViewVanilla };
